<template>
    <div>
        <b-card v-show="mostrarTabela" no-body>
            <b-card-header>
                <span class="h5">Solicitações de Acesso</span>
            </b-card-header>
            <b-card-body>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <app-tabela
                    idTabela="tblSolicitacoesAcesso"
                    :itens="solicitacoesAcessoFiltradas"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >
                    <template slot="botoes">
                        <b-row>
                            <b-col sm="12">
                                <b-form inline class="justify-content-end">
                                    <label class="mr-sm-2">Status</label>
                                    <b-form-select
                                        class="mb-2 mr-sm-2 mb-sm-0"
                                        :plain="true"
                                        :options="statusLista"
                                        v-model="statusSelecionado"
                                    ></b-form-select>
                                </b-form>
                            </b-col>
                        </b-row>
                    </template>
                    <template slot="cpfCnpjFornecedor" slot-scope="data">
                        <span v-if="data.cpfCnpjFornecedor.length == 11">{{
                            data.cpfCnpjFornecedor | toCpf
                        }}</span>
                        <span v-if="data.cpfCnpjFornecedor.length == 14">{{
                            data.cpfCnpjFornecedor | toCnpj
                        }}</span>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <span
                            class="text-primary"
                            v-if="$temAcessoView('CTRLACS-SOLACS-01')"
                        >
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="
                                    detalharSolicitacaoAcesso(
                                        data.solicitacaoAcessoId
                                    )
                                "
                            ></i>
                        </span>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
import SolicitacoesAcessoServicos from './SolicitacoesAcessoServicos'

export default {
    data() {
        return {
            erros: [],
            solicitacoesAcesso: [],
            solicitacoesAcessoFiltradas: [],
            statusSelecionado: 0,
            statusLista: [
                { value: -1, text: 'TODAS' },
                { value: 0, text: 'EM APROVAÇÃO' },
                { value: 1, text: 'APROVADA' },
                { value: 2, text: 'REPROVADA' }
            ],
            campos: [
                {
                    key: 'dataSolicitacao',
                    label: 'Data da Solicitação',
                    sortable: true,
                    type: 'date'
                },
                {
                    key: 'cpfCnpjFornecedor',
                    label: 'CNPJ/CPF',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'razaoSocialFornecedor',
                    label: 'Razão Social/Nome',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'tipoAcessoDescr',
                    label: 'Tipo Acesso',
                    sortable: true,
                    filterable: true,
                    type: 'status'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    sortable: true,
                    filterable: true,
                    type: 'status'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },
    methods: {
        obterSolicitacoesAcesso() {
            this.$store.dispatch('addRequest')
            SolicitacoesAcessoServicos.obterTodas(this.statusSelecionado).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.solicitacoesAcesso = response.data
                            this.solicitacoesAcessoFiltradas = response.data
                            // this.aplicarFiltroStatus()
                        } else {
                            this.erros = [
                                'Erro ao obter as Solicitações de Acesso'
                            ]
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        aplicarFiltroStatus() {
            if (this.statusSelecionado == -1) {
                this.solicitacoesAcessoFiltradas = this.solicitacoesAcesso
            } else {
                this.solicitacoesAcessoFiltradas = this.solicitacoesAcesso.filter(
                    item => {
                        return item.status == this.statusSelecionado
                    }
                )
            }
        },

        detalharSolicitacaoAcesso(solicitacaoAcessoId) {
            this.$router.push({
                name: 'SolicitacoesAcesso_Detalhar',
                params: {
                    solicitacaoAcessoId
                }
            })
        }
    },

    created() {
        this.obterSolicitacoesAcesso()
    },

    computed: {
        mostrarTabela() {
            return this.$route.name === 'SolicitacoesAcesso'
        }
    },

    watch: {
        $route(to, from) {
            if (to.name === 'SolicitacoesAcesso') {
                if (this.$store.getters.recarregar) {
                    this.obterSolicitacoesAcesso()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        },

        statusSelecionado() {
            this.obterSolicitacoesAcesso()
        }
    },

    components: {}
}
</script>
